import React from 'react';
const HubspotContext = React.createContext(null);
export default HubspotContext;
